import React, { useRef, useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogContent,
  IconButton,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { FaFilePdf, FaTimes, FaPencilAlt, FaFont, FaSave, FaEraser, FaUndo, FaRedo } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { addFormMTDoc } from "@egovernments/digit-ui-module-core/src/redux/actions/formMT";
import axios from "axios";
import { PdfViewerModal } from "@egovernments/digit-ui-module-common/src/sharedComponents/PdfViewerModal";
// Create a new component for PDF viewing and editing

const Step4 = ({ formData, handleTabChange, isEmployee, isNocModule, onSelect }) => {
  console.log("formDataInStep4", formData, formData?.natureOfConstruction, formData?.mapSubDetails?.viewEditPdf);
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const scrutinyFlow = formData?.scrutinyFlow === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const [drawingDetail, setDrawingDetail] = useState(formData?.drawingDetail || []);
  const drawingPdfflow = formData?.documents?.filter((e) => e.documentType === "drawingPdf") || [];
  const scrutinydxf = formData?.documents?.filter((e) => e.documentType === "dxfDrawing") || [];
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [currFileStoreId, setCurrFileStoreId] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const [editedPdfUrl, setEditedPdfUrl] = useState("");
  const formRef = useRef(null);
  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const validatePdfUrl = (url) => {
    try {
      const urlObj = new URL(url);
      console.log("PDF URL validation:", {
        protocol: urlObj.protocol,
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        search: urlObj.search,
        isValid: true,
      });
      return true;
    } catch (error) {
      console.error("Invalid PDF URL:", url, error);
      return false;
    }
  };
  console.log(drawingPdfflow, "pdfFlowwwww");
  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    // Validate URL before setting it
    if (!validatePdfUrl(url)) {
      showMessage("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrFileStoreId(drawingPdfflow?.[0]?.fileStoreId);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };

  console.log("EditedPDFURL", editedPdfUrl);

  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: "",
      };
      // const updatedDrawingDetail = drawingDetail.map((item) => ({
      //   ...item,
      //   viewEditPdf: fileStoreId,
      // }));
      const appData = {
        ...formData,
        workflow,
        // drawingDetail: updatedDrawingDetail,
        mapSubDetails: {
          ...formData?.mapSubDetails,
          viewEditPdf: fileStoreId,
        },
      };
      updateApiCall.mutate(
        { BPA: appData },
        {
          onSuccess: (result) => {
            console.log("resultFromUpdate", result);
            // setEditedPdfUrl(result?.BPA?.[0]?.drawingDetail[0]?.viewEditPdfUrl);
            onSelect("", result?.BPA?.[0]);
            // setDeveloperUpdateDocument("DocumentDetailsUpdated");
            // alert("Pdf Edited Succesfully");
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
    // Update the drawingDetail array with the new fileStoreId
    // if (documentIndex !== null && documentIndex !== undefined) {
    //   const updatedDrawingDetail = [...drawingDetail];
    //   updatedDrawingDetail[documentIndex] = {
    //     ...updatedDrawingDetail[documentIndex],
    //     viewEditPdfUrl: `/filestore/v1/files/id?fileStoreId=${fileStoreId}&tenantId=up&module=property-upload`,
    //   };
    //   setDrawingDetail(updatedDrawingDetail);
    // Also update the formData if needed
    // if (formData && formData.drawingDetail) {
    //   formData.drawingDetail[documentIndex] = updatedDrawingDetail[documentIndex];
    // }
    // }
  };
  const columns = [
    { id: "submissionIndex", label: "Submission", accessor: "" },
    { id: "viewPdf", label: "View Pdf", accessor: "viewPdf" },
    { id: "viewEditPdfUrl", label: "View Edited Pdf", accessor: "viewEditPdfUrl" },
    { id: "viewPlanReport", label: "View Plan Report", accessor: "viewPlanReport" },
    { id: "dxfFile", label: "DWG File", accessor: "dxfFile" },
    { id: "status", label: "Status", accessor: "status" },
    { id: "submittedOn", label: "Submitted On", accessor: "submittedOn" },
    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];
  // const pdfcolumns = [
  //   { id: "submissionIndex", label: "Submission", accessor: "" },
  //   { id: "dxfFile", label: "DXF File", accessor: "dxfFile" },
  //   { id: "drawingPdf", label: "Drawing Pdf", accessor: "drawingPdf" },
  //   { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  // ];

  const pdfcolumns = [
    { id: "submissionIndex", label: "Submission", accessor: "" },
    { id: "dxfFile", label: "DWG File", accessor: "dxfFile" },
    { id: "drawingPdf", label: "Drawing Pdf", accessor: "drawingPdf" },

    ...(isEmployee
      ? [
          {
            id: "viewEditPdf",
            label: "View Edited Pdf",
            accessor: "viewEditPdf",
          },
        ]
      : []),

    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];

  const handleClose = () => {
    setOpen(false);
  };
  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      // scrutinyFlow is true for PDF flow, false for EDCR flow (computed at line 36)
      // Citizen (LTP/applicant) EDCR flow → pdfType "D"
      // Citizen (LTP/applicant) PDF flow  → pdfType "DI"
      // Note: Employee DSC is handled separately via DscSanctionLetter (pdfType "SD" for EDCR)
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: scrutinyFlow ? "DI" : "D",
      };
      const getSign = await Digit.DscService.getSignParams({ SignRequest });
      setSigningParams((prev) => ({
        ...prev,
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      }));
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const getFileStoreId = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get("fileStoreId");
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };
  const viewEdittedPdf = (url, index) => {
    let newUrl = url;
    console.log("newURL123", url, editedPdfUrl);
    if (editedPdfUrl !== "") {
      newUrl = editedPdfUrl;
    }
    window.open(newUrl, "_blank");
  };
  const viewPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const handleOpenDoc = async (url) => {
    const fileStoreId = getFileStoreId(url);
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64 } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return <Loader />;
  }
  return (
    <section className="groupContainer">
      <form>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{scrutinyFlow ? t("Pdf Document") : t("Drawing")}</h2>
          </div>
        </div>

        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details  table">
            <TableHead
              sx={{
                backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
                color: "#fff",
              }}
            >
              <TableRow sx={{ height: "20px" }}>
                {!scrutinyFlow
                  ? columns.map((column) => (
                      <TableCell key={column.id} sx={{ color: "#fff" }}>
                        {column.label}
                      </TableCell>
                    ))
                  : pdfcolumns?.map((column) => (
                      <TableCell key={column.id} sx={{ color: "#fff" }}>
                        {column.label}
                      </TableCell>
                    ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!scrutinyFlow ? (
                drawingDetail.map((row, index) => (
                  <TableRow key={index}>
                    {columns.map((column) => {
                      if (column.id === "submissionIndex") {
                        return <TableCell key={column.id}>Uploaded Drawing PDF {index + 1}</TableCell>;
                      }
                      const value = row[column.accessor];
                      if (column.accessor === "submittedOn") {
                        return <TableCell key={column.id}>{value ? new Date(value).toLocaleString() : "N/A"}</TableCell>;
                      }
                      if (
                        column.accessor === "updatedDxfFile" ||
                        column.accessor === "planReport" ||
                        column.accessor === "viewPdf" ||
                        column.accessor === "viewPlanReport"
                      ) {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#a10505"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleOpenPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "viewPdf") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#157CB3"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => viewPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "viewEditPdfUrl") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <FaFilePdf
                                color="#157CB3"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => viewEdittedPdf(value, index)}
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "dxfFile") {
                        return (
                          <TableCell key={column.id}>
                            {value ? (
                              <img
                                src="https://i.imgur.com/GDoAGny.png"
                                style={{
                                  width: "20px",
                                  height: "30px",
                                  cursor: "pointer",
                                }}
                                onClick={() => window.open(value, "_blank")}
                                alt="DXF File"
                              />
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      if (column.accessor === "signedPdfUrl") {
                        // EDCR case: check last index of drawingDetail for signed file
                        const lastDetail = drawingDetail?.[drawingDetail.length - 1];
                        const signedPdfUrl = lastDetail?.signedPdfUrl;
                        const signedPdfId = lastDetail?.signedPdfId;
                        // Build URL from signedPdfId if direct URL not available
                        const signedFileUrl =
                          signedPdfUrl || (signedPdfId ? `/filestore/v1/files/id?fileStoreId=${signedPdfId}&tenantId=${tenantId}` : null);
                        // Citizen: hide button if signedPdfId is not null (already signed)
                        const isAlreadySigned = signedPdfId != null;

                        return (
                          <TableCell key={column.id}>
                            {isAlreadySigned && signedFileUrl ? (
                              // Signed — show clickable PDF icon
                              <FaFilePdf
                                color="#24b155"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => window.open(signedFileUrl, "_blank")}
                                title="View Signed PDF"
                              />
                            ) : !isEmployee ? (
                              // Not signed yet — show button for citizen only
                              <button
                                style={{
                                  backgroundColor: "#157CB3",
                                  color: "#fff",
                                  padding: "8px 16px",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  opacity: 1,
                                }}
                                type="button"
                                onClick={handleSign}
                                disabled={isEmployee}
                              >
                                Attach Digital Sign
                              </button>
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      }
                      return <TableCell key={column.id}>{value || "N/A"}</TableCell>;
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow key={1}>
                  {pdfcolumns.map((column, index) => {
                    if (column.id === "submissionIndex") {
                      return <TableCell key={index}>Upload Drawing PDF {index + 1}</TableCell>;
                    }
                    if (column.accessor === "dxfFile") {
                      return (
                        <TableCell>
                          {scrutinydxf?.[0]?.fileStoreId ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => getDocumentByFileStoreId(scrutinydxf?.[0]?.fileStoreId, setIsPreviewLoading)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    // if (column.accessor === "drawingPdf") {
                    //   return (
                    //     <TableCell>
                    //       {drawingPdfflow?.[0]?.fileStoreId ? (
                    //         <FaFilePdf
                    //           color="#a10505"
                    //           style={{
                    //             width: "20px",
                    //             height: "20px",
                    //             cursor: "pointer",
                    //           }}
                    //           onClick={() => getDocumentByFileStoreId(drawingPdfflow?.[0]?.fileStoreId, setIsPreviewLoading)}
                    //         />
                    //       ) : (
                    //         "N/A"
                    //       )}
                    //     </TableCell>
                    //   );
                    // }
                    if (column.accessor === "drawingPdf") {
                      return (
                        <TableCell>
                          {(isEmployee ? formData?.drawingPdfUrlSelf : drawingPdfflow?.[0]?.fileStoreId) ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (isEmployee) {
                                  handleOpenPdf(formData?.drawingPdfUrlSelf);
                                } else {
                                  getDocumentByFileStoreId(drawingPdfflow?.[0]?.fileStoreId, setIsPreviewLoading);
                                }
                              }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "viewEditPdf" && isEmployee) {
                      return (
                        <TableCell>
                          {formData?.mapSubDetails?.viewEditPdf ? (
                            <FaFilePdf
                              color="#157CB3"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => getDocumentByFileStoreId(formData?.mapSubDetails?.viewEditPdf, setIsPreviewLoading)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "signedPdfUrl") {
                      return (
                        <TableCell>
                          {formData?.IsSignedDrawingPdfURL === true && formData?.signedDrawingPdfURL ? (
                            <FaFilePdf
                              color="#24b155"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => window.open(formData.signedDrawingPdfURL, "_blank")}
                              title="View Signed PDF"
                            />
                          ) : !isEmployee ? (
                            <button
                              style={{
                                backgroundColor: "#157CB3",
                                color: "#fff",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                opacity: 1,
                              }}
                              type="button"
                              onClick={handleSign}
                              disabled={isEmployee}
                            >
                              Attach Digital Sign
                            </button>
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* PDF Viewer Modal */}
        <PdfViewerModal
          open={pdfModalOpen}
          onClose={handlePdfModalClose}
          pdfUrl={currentPdfUrl}
          onSave={handlePdfSave}
          fileStoreId={currFileStoreId}
          documentIndex={currentDocumentIndex}
        />
        {/* Modal overlay */}
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <p style={{ margin: "15px" }}>By clicking on the Submit button, you will be redirected to the Third-Party Page.</p>
            <form
              id="PDFViewerDemo"
              method="POST"
              ref={formRef}
              onSubmit={handleSubmit(onSubmit)}
              action="https://digital.abmapplication.com/Console/PdfViewerSigning"
            >
              <input type="hidden" id="AuthToken" name="AuthToken" value={signingParams.AuthToken} />
              <input type="hidden" id="SignSettingName" name="SignSettingName" value={signingParams.SignSettingName} />
              <input type="hidden" id="SrcPdfB64" name="SrcPdfB64" value={signingParams.SrcPdfB64} />
              <input type="hidden" id="SrcPdfPath" name="SrcPdfPath" value="" />
              <input type="hidden" id="SignedPdfPath" name="SignedPdfPath" value="" />
              <input type="hidden" id="UserDataJson" name="UserDataJson" value={signingParams.UserDataJson} />
              <input
                type="hidden"
                id="ReturnUrl"
                name="ReturnUrl"
                value={signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"}
              />

              <div className="button-inline">
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Submit"
                    type="submit"
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="button"
                onClick={() =>
                  formData?.IsSignedDrawingPdfURL === true && formData?.signedDrawingPdfURL ? handleTabChange(3) : alert("Please attach the DSC")
                }
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default Step4;
